import { inject, injectWithTransform, singleton } from "tsyringe";
import { Logger, LoggerTransformer } from "@identity/utils";
import { FacilitatedTesting } from "./FacilitatedTesting";
export * from "./FacilitatedTesting";

@singleton()
export class GooglePrivacySandbox {
  constructor(
    @injectWithTransform(Logger, LoggerTransformer, "GooglePrivacySandbox")
    private readonly logger: Logger,
    @inject(FacilitatedTesting)
    private readonly facilitatedTesting: FacilitatedTesting,
  ) {}

  public init(): void {
    this.logger.info("GooglePrivacySandbox init");
    this.facilitatedTesting.init();
  }
}
